// src/pages/TokenPage.js
import React, { useContext, useEffect, useState } from "react";
import "./TokenPage.css";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";

const ENV_TOKEN = process.env.REACT_APP_ENTRY_TOKEN; // CRA env

export default function TokenPage() {
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const { isAuthed, login } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // 이미 로그인되어 있으면 홈(루트)로
  useEffect(() => {
    if (isAuthed) {
      navigate("/", { replace: true });
    }
  }, [isAuthed, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    const VALID = (ENV_TOKEN && String(ENV_TOKEN)) || "EVERYOUNG-ADMIN";

    if (token.trim() === VALID) {
      login();
      const redirectTo = location.state?.from?.pathname || "/";
      navigate(redirectTo, { replace: true });
    } else {
      setError("토큰이 올바르지 않습니다.");
    }
  };

  return (
    <div className="token-wrap">
      <form className="token-card" onSubmit={handleSubmit}>
        <h1>접속 토큰 입력</h1>
        <input
          type="password"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="토큰을 입력하세요"
          autoFocus
        />
        <button type="submit">확인</button>
        {error && <p className="error">{error}</p>}
      </form>
    </div>
  );
}